export function truncateEmail(email: string, maxLength: number = 15): string {
  const [localPart, domain] = email.split('@');

  if (!domain) return email;

  if (localPart.length <= maxLength) {
    return email;
  }

  return `${localPart.slice(0, maxLength)}...@${domain}`;
}
